/**
 * Encryption module for credit cards
 */

import { env } from '../../../helpers/env'
import { logError } from '../../../helpers/logError'

const stringToCreditCardExpiry = (validTo: string) => {
  const s = validTo.split('/')
  return {
    month: s[0]?.length === 1 ? `0${s[0]}` : s[0], // Pad single digit months to double for correct format
    year: s[1],
  }
}

export interface CreditCardEncryptInfo {
  cardNumber: string
  cardExpiry: string
  cardCVC: string
}

export const encryptCard = async (card: CreditCardEncryptInfo): Promise<string | undefined> => {
  try {
    const { year, month } = card?.cardExpiry
      ? stringToCreditCardExpiry(card?.cardExpiry)
      : { year: undefined, month: undefined }
    const cardForEncryption = { cardNumber: card.cardNumber, expiryMonth: month, expiryYear: year, cvv: card.cardCVC }
    const result = verifone.encryptCard(cardForEncryption, env.lbPublicKey)
    if (result && typeof result.then === 'function') {
      const encrypted = await result
      return encrypted
    } else {
      throw new Error('Encryption did not return a promise')
    }
  } catch (error) {
    logError(`Card encryption error: ${error}`)
    throw error
  }
}
